import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=1d720e3e&scoped=true"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"
import style0 from "./Doc.vue?vue&type=style&index=0&id=1d720e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d720e3e",
  null
  
)

export default component.exports